import { openDB, DBSchema, IDBPDatabase } from 'idb';
import { Carton } from '../types';

interface CartonCacheDB extends DBSchema {
  cartonDetails: {
    key: string;
    value: Carton;
    indexes: { 'by-id': string };
  };
}

class CartonCacheService {
  private db: IDBPDatabase<CartonCacheDB> | null = null;
  private readonly DB_NAME = 'cartonCache';
  private readonly STORE_NAME = 'cartonDetails';
  private readonly VERSION = 1;

  async init() {
    if (!this.db) {
      this.db = await openDB<CartonCacheDB>(this.DB_NAME, this.VERSION, {
        upgrade(db) {
          if (!db.objectStoreNames.contains('cartonDetails')) {
            const store = db.createObjectStore('cartonDetails', { keyPath: 'id' });
            store.createIndex('by-id', 'id');
          }
        },
      });
    }
    return this.db;
  }

  async cacheCartonDetails(carton: Carton) {
    const db = await this.init();
    await db.put('cartonDetails', carton);
  }

  async getCartonDetails(cartonId: string): Promise<Carton | undefined> {
    const db = await this.init();
    return db.get('cartonDetails', cartonId);
  }

  async getAllCachedCartons(): Promise<Carton[]> {
    const db = await this.init();
    return db.getAll('cartonDetails');
  }

  async clearCache() {
    const db = await this.init();
    await db.clear('cartonDetails');
  }
}

export const cartonCacheService = new CartonCacheService(); 